import { Button, Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import SimpleDialog from '../components/dialogs/SimpleDialog';
import { useSimpleConfirmDialogStyles } from '../components/dialogs/SimpleConfirmDialog.styles';
import { FAIcon } from '../components/adapters/fontAwesomeAdapters';
import { useQuoteChangeWarningStyles } from './QuoteChangeWarning.styles';

export const QuoteChangeWarning = ({
  warningVisible,
  onReset,
  onQuoteDisconnect,
  onQuoteReuse,
}) => {
  const { styles } = useQuoteChangeWarningStyles();
  const { styles: simpleConfirmDialogStyles } = useSimpleConfirmDialogStyles();
  return (
    <SimpleDialog
      className={classNames(
        simpleConfirmDialogStyles.simpleConfirmDialog,
        styles.quoteChangeWarning
      )}
      icon={<FAIcon icon="exclamation-triangle" className="size-sm" />}
    >
      <div className={styles.content}>
        <Typography.Title level={1}>
          <FormattedMessage id="titles.attention" />
        </Typography.Title>
        <div className="nl-as-newline">
          <FormattedMessage id="book.newShipment.quoteChanged" />
        </div>
        <p>
          <b>
            <FormattedMessage id="buttons.cancel" />:{' '}
          </b>
          <FormattedMessage id="book.newShipment.quoteExpiredCancel" />
        </p>
        <p>
          <b>
            <FormattedMessage id="book.newShipment.quoteExpiredRemove.short" />
            :{' '}
          </b>
          <FormattedMessage id="book.newShipment.quoteExpiredRemove" />
        </p>
        <p>
          <b>
            <FormattedMessage id="book.newShipment.quoteExpiredReuse.short" />
            :{' '}
          </b>
          <FormattedMessage id="book.newShipment.quoteExpiredReuse" />
        </p>
      </div>
      <div className={styles.controls}>
        <Button onClick={onReset}>
          <FormattedMessage id="buttons.cancel" />
        </Button>
        <Button onClick={onQuoteDisconnect}>
          <FormattedMessage id="book.newShipment.quoteExpiredRemove.short" />
        </Button>
        <Button onClick={onQuoteReuse}>
          <FormattedMessage id="book.newShipment.quoteExpiredReuse.short" />
        </Button>
      </div>
    </SimpleDialog>
  );
};
